(function() {
  const itemsToShow = 6;
  const galleryGrid = document.querySelector('.promo__grid');
  const moreButton = document.querySelector('.more__btn');
  
  if (!galleryGrid) return;
  
  // Получаем все элементы фильтров
  const whoFilter = document.querySelector('select[name="who"]');
  const whenFilter = document.querySelector('select[name="when"]');
  const timeFilter = document.querySelector('select[name="time"]');
  

  
  // Сохраняем оригинальные элементы (для восстановления при фильтрации)
  const originalGalleryItems = Array.from(galleryGrid.children);
  let currentFilteredItems = [...originalGalleryItems];
  let visibleCount = 0;
  let currentFilters = {
    who: '1',
    when: '1',
    time: '1'
  };
  
  // Добавляем CSS класс для анимации
  const style = document.createElement('style');
  style.textContent = `
    .promo-preview {
      transition: opacity 0.3s ease, transform 0.3s ease;
    }
    .promo-preview.hidden {
      opacity: 0;
      transform: scale(0.8);
      pointer-events: none;
    }
    .promo-preview.filtered-out {
      display: none !important;
    }
    .promo__grid {
      transition: all 0.3s ease;
    }
  `;
  document.head.appendChild(style);
  
  // Функция фильтрации элементов
  function filterItems() {
    const filtered = originalGalleryItems.filter(item => {
      let matches = true;
      
      // Здесь можно добавить логику фильтрации на основе data-атрибутов или содержимого
      // Пример: если у элементов есть data-атрибуты для фильтрации
      const itemWho = item.getAttribute('data-who') || '1';
      const itemWhen = item.getAttribute('data-when') || '1';
      const itemTime = item.getAttribute('data-time') || '1';
      
      if (currentFilters.who !== '1' && itemWho !== currentFilters.who) {
        matches = false;
      }
      
      if (currentFilters.when !== '1' && itemWhen !== currentFilters.when) {
        matches = false;
      }
      
      if (currentFilters.time !== '1' && itemTime !== currentFilters.time) {
        matches = false;
      }
      
      return matches;
    });
    
    // Анимируем скрытие/показ
    originalGalleryItems.forEach(item => {
      if (!filtered.includes(item)) {
        item.classList.add('filtered-out');
      } else {
        item.classList.remove('filtered-out');
      }
    });
    
    currentFilteredItems = filtered;
    
    // Сбрасываем видимый счетчик
    visibleCount = 0;
    
    // Обновляем кнопку "Показать еще"
    const promoMore = moreButton ? moreButton.closest('.promo__more') : null;
    if (moreButton) {
      if (currentFilteredItems.length <= itemsToShow) {
        if (promoMore) promoMore.style.display = 'none';
      } else {
        if (promoMore) promoMore.style.display = '';
      }
    }
    
    // Показываем первые элементы
    showMore();
  }
  
  function updateVisibility() {
    currentFilteredItems.forEach((item, index) => {
      if (index < visibleCount) {
        item.classList.remove('hidden');
        // Удаляем display none если элемент не отфильтрован
        if (!item.classList.contains('filtered-out')) {
          item.style.display = '';
        }
      } else {
        item.classList.add('hidden');
        setTimeout(() => {
          if (item.classList.contains('hidden') && !item.classList.contains('filtered-out')) {
            item.style.display = 'none';
          }
        }, 300);
      }
    });
    
    // Скрываем кнопку если все элементы показаны
    const promoMore = moreButton ? moreButton.closest('.promo__more') : null;
    if (moreButton && visibleCount >= currentFilteredItems.length) {
      if (promoMore) promoMore.style.display = 'none';
    } else if (moreButton && promoMore) {
      promoMore.style.display = '';
    }
  }
  
  function showMore() {
    const newCount = Math.min(visibleCount + itemsToShow, currentFilteredItems.length);
    
    // Сначала показываем элементы
    for (let i = visibleCount; i < newCount; i++) {
      const item = currentFilteredItems[i];
      if (!item.classList.contains('filtered-out')) {
        item.style.display = '';
        setTimeout(() => {
          item.classList.remove('hidden');
        }, 10);
      }
    }
    
    visibleCount = newCount;
    updateVisibility();
  }
  
 
  
  // Закрытие селектов при клике вне их
  document.addEventListener('click', function(e) {
    if (!e.target.closest('.custom-select-container')) {
      document.querySelectorAll('.custom-select-container.active').forEach(container => {
        container.classList.remove('active');
      });
    }
  });
  
  // Инициализация кнопки "Показать еще"
  if (moreButton) {
    moreButton.addEventListener('click', showMore);
  }
  
 
  
  // Инициализация отображения
  const dataCount = parseInt(galleryGrid.getAttribute('data-count'), 10);
  const initialCount = isNaN(dataCount) ? itemsToShow : dataCount;
  visibleCount = Math.min(initialCount, originalGalleryItems.length);
  currentFilteredItems = [...originalGalleryItems];
  
  // Добавляем начальные data-атрибуты для элементов (пример)
  // В реальном проекте эти данные должны приходить с сервера или быть в разметке
  originalGalleryItems.forEach((item, index) => {
    item.classList.add('gallery__item');
    
    // Пример добавления data-атрибутов на основе индекса или содержимого
    if (!item.hasAttribute('data-who')) {
      // Здесь можно задать логику определения категории элемента
      const category = (index % 3) + 1; // Пример: распределяем по категориям
      item.setAttribute('data-who', category.toString());
    }
    if (!item.hasAttribute('data-when')) {
      item.setAttribute('data-when', '1');
    }
    if (!item.hasAttribute('data-time')) {
      item.setAttribute('data-time', '1');
    }
    
    if (index >= visibleCount) {
      item.classList.add('hidden');
      item.style.display = 'none';
    }
  });
  
  // Обработчик для нативных select (на случай если кастомные не работают)
  if (whoFilter) {
    whoFilter.addEventListener('change', function(e) {
      currentFilters.who = e.target.value;
      filterItems();
    });
  }
  
  if (whenFilter) {
    whenFilter.addEventListener('change', function(e) {
      currentFilters.when = e.target.value;
      filterItems();
    });
  }
  
  if (timeFilter) {
    timeFilter.addEventListener('change', function(e) {
      currentFilters.time = e.target.value;
      filterItems();
    });
  }
})();